<button mat-icon-button (click)="openSettings()" style="margin: 0 15px">
    <mat-icon>settings</mat-icon>
</button>